import {
  refusalDestinationIdOf,
  type RefusalDestinationIdType,
} from '@featit/shared/refusal-destination-catalogue';
import { GraphqlRequestError } from './graphqlRequestError';

/**
 * T-0824 (I-1914): the place a failed request's refusal names, as the server sent it beside the
 * sentence — from a REST answer's body or a GraphQL error's original one. Null for anything else,
 * so a screen that holds its failure as a string keeps this beside it and links nothing without it.
 */
export function refusalDestinationOfError(error: unknown): RefusalDestinationIdType | null {
  if (error instanceof GraphqlRequestError) {
    return refusalDestinationIdOf(error.extensions.originalError);
  }
  const response = (error as { response?: { data?: unknown } } | null | undefined)?.response;
  return refusalDestinationIdOf(response?.data);
}
